<script>
    import {subscriptionConfig} from "../../config/client.js";
    import {createEventDispatcher} from "svelte";
    import { onDestroy } from "svelte";
    import { t } from '../services/translation/translationService.js';

    const searchTypes = Object.keys(subscriptionConfig.searchTypes);
    const dispatch = createEventDispatcher();
    let searchType = 'basic';
    let isOpen = false;

    function selectType(selectedType) {
        searchType = selectedType;
        isOpen = false;
        // Emit the 'typeSelected' event with the selected type
        dispatch('typeSelected', {searchType});
    }

    function handleClickOutside(event) {
        if (!event.target.closest('.custom-select')) {
            isOpen = false;
        }
    }

    window.addEventListener('click', handleClickOutside);
    
    onDestroy(() => {
        window.removeEventListener('click', handleClickOutside);
    });

    function toggleDropdown() {
        isOpen = !isOpen;
    }

    function getSearchTypeUsage(type) {
        const x = JSON.parse(localStorage.getItem('searchUsage') || '');
        return x[type] || '0'
    }
</script>
<style>
    .custom-select {
        position: relative;
        width: 155px; /* Increased by 1/8 more */
        display: inline-block;
        margin-top: -5px;
        margin-left: 0; /* Ensure left alignment */
        cursor: pointer;
        flex-shrink: 0; /* Prevent shrinking */
    }

    .select-toggle {
        padding: 8px 12px;
        border: 1px solid #003476;
        background-color: #ffffff;
        color: #003476;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 4px;
        transition: background-color 0.3s, color 0.3s;
        font-weight: 500;
        letter-spacing: 0.5px;
        white-space: nowrap;
        width: 100%; /* Fill the container */
        box-sizing: border-box;
    }

    .select-toggle:hover {
        background-color: #f0f0f0;
    }

    .dropdown {
        position: absolute;
        top: calc(100% - 8px); /* Adjust to remove gap */
        left: 0;
        width: 100%;
        background: white;
        z-index: 10;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
        box-sizing: border-box;
        border: none;
        visibility: hidden;
    }

    .dropdown.open {
        max-height: 200px;
        visibility: visible;
        border: 1px solid #003476;
        border-top: none;
        border-radius: 0 0 4px 4px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .option {
        padding: 8px 12px;
        text-transform: capitalize;
        transition: background-color 0.2s;
        white-space: nowrap;
        background: none;
        border: none;
        width: 100%;
        text-align: left;
        cursor: pointer;
    }

    .option:hover {
        background-color: #f0f0f0;
    }

    .arrow {
        transition: transform 0.3s ease;
        margin-left: 8px;
    }

    .arrow.up {
        transform: rotate(180deg);
    }

    .search-type-text {
        text-transform: capitalize;
        font-size: 1rem;
    }
</style>
<div class="custom-select">
    <!-- Dropdown Toggle -->
    <button class="select-toggle" on:click={toggleDropdown}>
        <span class="search-type-text">{$t(searchType)}</span>
        <span class="arrow {isOpen ? 'up' : 'down'}">▼</span>
    </button>

    <!-- Dropdown Options -->
    <div class="dropdown {isOpen ? 'open' : ''}">
        {#each searchTypes as type}
            <button 
                class="option" 
                on:click={() => selectType(type)}
                on:keydown={(e) => e.key === 'Enter' && selectType(type)}
            >
                {$t(type)}
            </button>
        {/each}
    </div>
</div>
